var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouseinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.634 14.116 15.884.366a1.25 1.25 0 0 0-1.768 0L.366 14.116a1.25 1.25 0 0 0 .884 2.134h1.562a.313.313 0 0 1 .313.312V28.75A1.25 1.25 0 0 0 4.375 30h7.187a.313.313 0 0 0 .313-.313V23.75a3.125 3.125 0 0 1 6.25 0v5.937a.313.313 0 0 0 .312.313h7.188a1.25 1.25 0 0 0 1.25-1.25V16.562a.313.313 0 0 1 .312-.312h1.563a1.25 1.25 0 0 0 .884-2.134M15 15a3.125 3.125 0 1 1 0-6.25A3.125 3.125 0 0 1 15 15"
})));
export default SvgHouseinline;